import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import moment from 'moment'
import { Helmet } from 'react-helmet';
import { Text, Tag } from '../../Reusable/Text';
import { StyledExtLink, StyledLink } from '../../Reusable/Link'
import { Image } from '../../Reusable/Image';
import { Flex, FlexColumn, Container, Card, CardContainer } from '../../Reusable/Container';
import { Modal, Skeleton } from 'antd'
import { TextButton } from '../../Reusable/Button';
import { ErrorAlert } from '../../Reusable/Alert';
import AlertModal from '../../Reusable/AlertModal'
import AionLogo from '../../Reusable/Image';
import CircleLoader from '../../Reusable/CircleLoader'
import AionLinkLogo from "../../../Images/aion.svg"
import { flowViewsData, applyDoneStep } from './viewData';
import { apiPOSTReq, doSignout } from '../../../Utils/api';
import { isMobile, toCurrency, getBPAccountsWithAccess, formatPhoneTextV2 } from '../../../Utils/util'
import environment from '../../../environment';
import Welcome from './Welcome';
import PaymentInformation from './PaymentInformation';
import AutoDebitInformation from './AutoDebitInformation';
import PaymentOptions from './PaymentOptions';
import SignInModal from '../../Authentication/SigninModal';
import ModalClose from '../../../Images/modal-close.png'
import AICPAAutoDebit from './AICPAAutoDebit';
import PoweredByAion from '../../Reusable/PoweredByAion';
import Call from '../../../Images/call-dark.svg'
import Email from '../../../Images/email-dark.svg'
import Profile from '../../../Images/profile-dark.svg'
import Exclamation from '../../../Images/exclamation.svg'

import { addDataToStore, BNK_SAVE_DATA } from '../../../Actions/actions';
import { apiPOSTNoAuth } from '../../../Utils/api';


class AutoDebitPaymentMethod extends Component {

    state = {
        submitLoading: false,
        loading: true,
        step: 0,
        flowSteps: [
            "Your Information",
            "Credentials"
        ],
        preboardUser: {},
        applicationStep: 0,
        getStarted: true,
        getStartedLoading: true,
    }

    componentDidMount() {
        const urlStr = this.props.location.search.replace('?', '')
        const refNum = (new URLSearchParams(urlStr).get('refNum') || '')

        window.scroll({ top: 0, behavior: 'smooth' })
        var Accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: true })
        this.setState({ accounts: Accounts, refNum: refNum }, () => this.getAutoDebitCustomer())
    }

    getAutoDebitCustomer = () => {
        const { refNum } = this.state

        console.log("CustomerPayment getAutoDebitCustomer body", { ReferenceNum: refNum })

        apiPOSTNoAuth(`${environment.iveBaseUrl}/ive/bc/getAutoDebitCustomer`, { AionAuth: refNum }, { ReferenceNum: refNum }, (err, resp) => {
            try {
                if (err) throw Error(err)
                var data = (resp || {}).data || {}
                console.log("CustomerPayment getAutoDebitCustomer data", err, data)
                if (!data.result) throw Error(data.responseMessage || data.error)
                this.setState({
                    customer: data.customer,
                    customerPaymentMethod: data.customerPaymentMethod,
                    invoice: data.invoice,
                    attachmentUrl: data.attachmentUrl,
                    paymentAmount: data.invoice?.balance,
                    email: data.inviteInfo?.emailId || data.referralInfo?.customerEmail || data.customer?.primaryEmailAddress?.address || null,
                    name: data.referralInfo?.customerName,
                    referralInfo: data.referralInfo,
                    business: data.business,
                    inviteInfo: data.inviteInfo,
                })
            } catch (error) {
                console.log("CustomerPayment getAutoDebitCustomer error", error)
                // ErrorAlert({ description: error.message || "Sorry, we had trouble fetching your invite. Please try again." })
            } finally {
                this.setState({ getStartedLoading: false, loading: false })
            }
        })
    }

    getAccounts = () => {
        this.setState({ aionAccountsLoading: true })

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getAccounts`, { "BankProvider": environment.bankProvider.crb }, null, (err, resp) => {
            try {
                console.log("CustomerPayment /bb/getAccounts", err, resp);
                const data = resp || {};
                if (data.result) {
                    if (err) throw new Error(err)
                    var accounts = data.bbaccounts

                    console.log("CustomerPayment /bb/getAccounts", accounts)

                    var zeroBalance = true
                    var crb = false

                    accounts.forEach(account => {
                        if (account.bankProvider === "CrossRiverBank") {
                            crb = true
                        }
                        if (account.currentBalance != 0) {
                            zeroBalance = false
                        }
                    })

                    this.setState({ accounts })
                    this.props.dispatch(addDataToStore(BNK_SAVE_DATA, { BBAccounts: accounts }))
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("CustomerPayment ERRR getAccounts", error, err, resp);
                const fd = this.fetchData;
                // ErrorAlert({ description: error.message });
            } finally {
                this.setState({ aionAccountsLoading: false })
            }
        })
    }

    pay = (payByAion, fromAccount) => {
        console.log("CustomerPayment pay payByAion, fromAccount", payByAion, fromAccount)
        const { refNum } = this.state
        const { invoice, customer, name, email, accounts } = this.state

        // const { invoiceId, balance } = invoice
        const { customerId, businessId, displayName } = customer
        const paymentAmount = 1

        if (!name) {
            this.setState({ errorField: 'name', errorMessage: 'Name is a required field' })
            return
        }
        if (!email) {
            this.setState({ errorField: 'email', errorMessage: 'Email is a required field' })
            return
        }
        if (fromAccount && (paymentAmount > fromAccount?.availableBalance)) {
            this.setState({ errorField: 'paymentAmount', errorMessage: `Payment amount cannot exceed your available balance of $${toCurrency(fromAccount?.availableBalance)}` })
            return
        }
        if (isNaN(paymentAmount)) {
            this.setState({ errorField: 'paymentAmount', errorMessage: 'Enter a valid payment amount' })
            return
        }
        if (payByAion && !fromAccount) {
            this.setState({ errorField: 'fromAccount', errorMessage: 'Select your Aion account to continue' })
            return
        }

        const { accountName, accountNumber, routingNumber, accountSubType, confirmAccountNumber, loggedIn, bankName, logoUrl } = fromAccount || {}

        if (!routingNumber) {
            this.setState({ errorField: 'routingNumber', errorMessage: 'Routing number is a required field' })
            return
        }
        if (isNaN(routingNumber)) {
            this.setState({ errorField: 'routingNumber', errorMessage: 'Please enter a valid 9 digit routing number' })
            return
        }
        if (routingNumber?.length !== 9) {
            this.setState({ errorField: 'routingNumber', errorMessage: 'Routing number must be exactly 9 digits' })
            return
        }
        if (!accountNumber) {
            this.setState({ errorField: 'accountNumber', errorMessage: 'Account number is a required field' })
            return
        }
        if ((!payByAion || loggedIn === false) && !confirmAccountNumber) {
            this.setState({ errorField: 'confirmAccountNumber', errorMessage: 'Confirm account number is a required field' })
            return
        }
        if ((!payByAion || loggedIn === false) && (accountNumber !== confirmAccountNumber)) {
            this.setState({ errorField: 'accountNumber', errorMessage: 'Account numbers do not match' })
            return
        }

        if ((!payByAion || loggedIn === false) && (!bankName || bankName === '')) {
            this.setState({ errorField: 'bankName', errorMessage: 'Bank name is a required field' })
            return
        }
        if (!accountSubType) {
            this.setState({ errorField: 'accountType', errorMessage: 'Select your account type to continue' })
            return
        }

        this.setState({ errorField: null, errorMessage: null })

        var body = {
            customerId: customerId,
            businessId: businessId,
            bankDetail: {
                bankName: bankName,
                accountName: accountName,
                accountNumber: accountNumber,
                routingNumber: routingNumber,
                accountType: accountSubType,
                logoUrl: logoUrl,
            },
            bankProvider: "CrossRiverBank",
            paymentMethodId: null, // paymentMethodId,
            customerName: name,
            name: name,
            customerEmail: email,
            userEmail: email,
            aionPay: payByAion,
            referenceNum: refNum,
        }

        console.log("CustomerPayment /ive/bc/createAutoDebitPaymentMethod header", { AionAuth: refNum, AionCurrentBiz: businessId })
        console.log("CustomerPayment /ive/bc/createAutoDebitPaymentMethod body", body)

        this.setState({ payLoading: true })

        apiPOSTNoAuth(`${environment.iveBaseUrl}/ive/bc/createAutoDebitPaymentMethod`, { AionAuth: refNum, AionCurrentBiz: businessId }, body, (err, resp) => {
            console.log("CustomerPayment /ive/bc/createAutoDebitPaymentMethod err resp", err, resp)
            this.setState({ submitLoading: false })
            try {
                if (err) throw Error(err)
                const data = resp.data || {}
                if (data.result) {
                    console.log("CustomerPayment /ive/bc/createAutoDebitPaymentMethod data ", data)
                    // if (approvalRequired) this.props.onApprovalAction()
                    if (accounts && accounts?.length > 0) this.signout()
                    this.setState({ paymentMethodAdded: true, accounts: null })
                    this.getAutoDebitCustomer()
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("CustomerPayment /ive/bc/createAutoDebitPaymentMethod err", error, error.stack)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            } finally {
                this.setState({ payLoading: false })
            }
        })
    }

    signout = () => {
        this.props.doSignout(this.props.history, null, true);
    }

    render() {
        const { theme } = this.props
        var { getStarted, name, email, paymentAmount, errorField, errorMessage, getStartedLoading, invoice, customer, loading, invoicePartiallyPaid, paymentMethodAdded,
            aionAccountsLoading, attachmentUrl, accounts, showSuccessModal, payLoading, referralInfo, business, lastPaidAmount, refNum, inviteInfo } = this.state
        var { payments, invoiceStatus } = invoice || {}
        var { feeLabel, verificationPull, emailExpiry, logoUrl, businessName, description, businessContactName, businessPhone, businessEmail } = inviteInfo || {}

        const isExpired = emailExpiry && moment().isSameOrAfter(moment(emailExpiry).add(1, 'day'), 'day');

        const ImageBox = styled.div`
            width: 48px;
            height: 48px;
            border-radius: 9.6px;
            background: url(${logoUrl}) lightgray 50% / cover no-repeat;
            box-shadow: 0px 0px 16px 0px rgba(102, 102, 102, 0.16);
            `;

        if (paymentMethodAdded) {
            return <>
                <Helmet>
                    <title>{businessName}</title>
                    <link rel="icon" type="image/png" href={logoUrl} />
                </Helmet>
                <FlexColumn
                    start
                    center
                    // className='main-left-padding'
                    fullWidth
                    fullHeight
                    // gap="136px"
                    style={{ paddingBottom: 48, background: "linear-gradient(105deg, #F7F7F9 39.85%,  #E6E6EC 97.2%), linear-gradient(239deg, #F7F7F9 25.62%, #E6E6EC 95.24%)" }}
                >
                    {/* <Flex fullWidth between centerHorizontally style={{ padding: isMobile ? '0 12px' : '0 84px' }}>
                    <AionLogo />

                    <div style={{ borderRadius: 24, background: 'var(--Solid-Primary-Blue-0, #F3FAFF)', padding: '4px 8px' }}>
                        <TextButton icon={<Image src={AionLinkLogo} />} text={<a target="_blank" href="https://www.aionfi.com">Try Aion for your business!</a>} underline weight='400' />
                    </div>
                </Flex> */}
                    <FlexColumn end center gap="8px" grow>
                        <ImageBox />
                        <Text size="16px" heading weight='600'>{businessName}</Text>
                        <Text size="16px" center width="320px">{description}</Text>
                    </FlexColumn>

                    <CardContainer padding="48px">
                        <FlexColumn grow fullWidth center gap="8px" style={{ marginBottom: 0 }}>
                            <CircleLoader isComplete={true} />
                            <Text weight="600" size="20px" color="#030342" margin="16px 0 0">Payment details added</Text>
                            <Text center size="16px" color="#4F4F78" height="24px">A debit of $1 has been initiated from your account. Please<br />allow up to 2 business days for this transaction to complete.</Text>
                        </FlexColumn>
                    </CardContainer>

                    <FlexColumn end centerH grow>
                        <PoweredByAion />
                        <Flex centerH gap="8px">
                            <StyledExtLink color='#8181A0' target="_blank" href="https://www.aionfi.com/legal" style={{ textDecoration: "underline", fontSize: 14 }}>Legal</StyledExtLink>
                            <Text color="#8181A0">|</Text>
                            <StyledExtLink color='#8181A0' target="_blank" href="https://www.aionfi.com/privacy" style={{ textDecoration: "underline", fontSize: 14 }}>Privacy</StyledExtLink>
                        </Flex>
                    </FlexColumn>
                </FlexColumn>
            </>
        }

        if (isExpired || verificationPull === true) {
            return <>
                <Helmet>
                    <title>{businessName}</title>
                    <link rel="icon" type="image/png" href={logoUrl} />
                </Helmet>
                <FlexColumn
                    start
                    center
                    // className='main-left-padding'
                    fullWidth
                    fullHeight
                    // gap="136px"
                    style={{ paddingBottom: 48, background: "linear-gradient(105deg, #F7F7F9 39.85%,  #E6E6EC 97.2%), linear-gradient(239deg, #F7F7F9 25.62%, #E6E6EC 95.24%)" }}
                >
                    {/* <Flex fullWidth between centerHorizontally style={{ padding: isMobile ? '0 12px' : '0 84px' }}>
                <AionLogo />

                <div style={{ borderRadius: 24, background: 'var(--Solid-Primary-Blue-0, #F3FAFF)', padding: '4px 8px' }}>
                    <TextButton icon={<Image src={AionLinkLogo} />} text={<a target="_blank" href="https://www.aionfi.com">Try Aion for your business!</a>} underline weight='400' />
                </div>
            </Flex> */}
                    <FlexColumn end center gap="8px" grow>
                        <ImageBox />
                        <Text size="16px" heading weight='600'>{businessName}</Text>
                        <Text size="16px" center width="320px">{description}</Text>
                    </FlexColumn>

                    <CardContainer padding="48px" style={{ width: 700 }}>
                        <FlexColumn grow fullWidth center gap="8px" style={{ marginBottom: 0 }}>
                            <Image src={Exclamation} size="48px" />
                            <Text weight="600" size="20px" color="#030342" margin="16px 0 0">Link expired</Text>
                            <Text center size="16px" color="#4F4F78" height="24px">The billing link sent to you has expired please<br />contact us to receive a new link</Text>

                            <FlexColumn start center gap="12px" fullWidth style={{ marginTop: 48 }}>
                                <Text size="16px" heading weight='600'>Contact details</Text>
                                <FlexColumn start left gap="8px">
                                    {
                                        businessContactName &&
                                        <Flex start gap='8px' centerH>
                                            <Image src={Profile} size="30px" />
                                            <Text size="16px">{businessContactName}</Text>
                                        </Flex>
                                    }
                                    {
                                        businessPhone &&
                                        <Flex end gap='8px' centerH>
                                            <Image src={Call} size="30px" />
                                            <Text size="16px">{formatPhoneTextV2(businessPhone)}</Text>
                                        </Flex>
                                    }
                                    {
                                        businessEmail &&
                                        <Flex start gap='8px' centerH>
                                            <Image src={Email} size="30px" />
                                            <Text size="16px">{businessEmail}</Text>
                                        </Flex>
                                    }
                                </FlexColumn>
                            </FlexColumn>
                        </FlexColumn>
                    </CardContainer>

                    <FlexColumn end centerH grow>
                        <PoweredByAion />
                        <Flex centerH gap="8px">
                            <StyledExtLink color='#8181A0' target="_blank" href="https://www.aionfi.com/legal" style={{ textDecoration: "underline", fontSize: 14 }}>Legal</StyledExtLink>
                            <Text color="#8181A0">|</Text>
                            <StyledExtLink color='#8181A0' target="_blank" href="https://www.aionfi.com/privacy" style={{ textDecoration: "underline", fontSize: 14 }}>Privacy</StyledExtLink>
                        </Flex>
                    </FlexColumn>
                </FlexColumn>
            </>
        }

        return (
            <>
                <Helmet>
                    <title>{businessName}</title>
                    <link rel="icon" type="image/png" href={logoUrl} />
                </Helmet>
                <Flex between className='main-left-padding' fullWidth fullHeight style={{ marginBottom: 0, padding: loading && 24 }}>

                    {
                        isMobile ?
                            <>
                                <FlexColumn start left gap='24px' fullWidth style={{ paddingBottom: 24, marginBottom: 0 }}>
                                    <Skeleton loading={loading} active title={false} paragraph={{ rows: 33 }}>
                                        <PaymentOptions
                                            aionAccountsLoading={aionAccountsLoading}
                                            payLoading={payLoading}
                                            onLogin={() => this.setState({ showSignIn: true })}
                                            accounts={accounts}
                                            pay={this.pay}
                                            errorField={errorField}
                                            errorMessage={errorMessage}
                                        />
                                    </Skeleton>
                                </FlexColumn>
                            </>
                            :
                            <>
                                <FlexColumn start fullHeight style={{ padding: isMobile ? '0 12px' : '0 84px', flex: 1 }}>
                                    {/* 
                                    <Flex fullWidth start centerHorizontally style={{ marginBottom: 32 }}>
                                        <AionLogo />
                                    </Flex> */}

                                    <FlexColumn fullWidth fullHeight centerHorizontally>
                                        <FlexColumn center gap="80px" style={{ width: loading ? 720 : "100%", marginBottom: 120, padding: loading ? 48 : 0 }}>

                                            <Skeleton loading={loading} active title={true} paragraph={{ rows: 25 }}>
                                                <FlexColumn start center gap="8px">
                                                    <ImageBox />
                                                    <Text size="16px" heading weight='600'>{businessName}</Text>
                                                    <Text size="16px" center width="320px">{description}</Text>
                                                </FlexColumn>

                                                <FlexColumn start center gap="12px">
                                                    <Text size="16px" heading weight='600'>{feeLabel}</Text>
                                                    <Flex start bottom>
                                                        <Text bottom size="32px" weight="600" height='8px' color={theme.colors.primary2}>$1</Text>
                                                        <Text bottom size="20px" weight="400" height='0' color={theme.colors.primary2} style={{ marginLeft: 2 }}>.00</Text>
                                                    </Flex>
                                                </FlexColumn>

                                                <FlexColumn start center gap="12px" fullWidth>
                                                    <Text size="16px" heading weight='600'>Contact details</Text>
                                                    {
                                                        businessContactName &&
                                                        <Flex start gap='8px' centerH>
                                                            <Image src={Profile} size="30px" />
                                                            <Text size="16px">{businessContactName}</Text>
                                                        </Flex>
                                                    }
                                                    <Flex center gap="24px" fullWidth>
                                                        {
                                                            businessPhone &&
                                                            <Flex end gap='8px' style={{ width: "50%" }} centerH>
                                                                <Image src={Call} size="30px" />
                                                                <Text size="16px">{formatPhoneTextV2(businessPhone)}</Text>
                                                            </Flex>
                                                        }
                                                        {
                                                            businessEmail &&
                                                            <Flex start gap='8px' style={{ width: "50%" }} centerH>
                                                                <Image src={Email} size="30px" />
                                                                <Text size="16px">{businessEmail}</Text>
                                                            </Flex>
                                                        }
                                                    </Flex>
                                                </FlexColumn>
                                            </Skeleton>
                                        </FlexColumn>
                                    </FlexColumn>
                                </FlexColumn>

                                <FlexColumn start centerHorizontally fullHeight style={{ background: 'white', width: 742, minWidth: 742, overflowY: 'auto', padding: loading ? 48 : "0 0 24px" }}>
                                    <Skeleton loading={loading} active title={true} paragraph={{ rows: 25 }}>
                                        <FlexColumn start gap="0" fullWidth style={{ padding: "24px 24px 0" }}>
                                            <Text size="24px" heading weight='600'>Enter Payment Details</Text>
                                            <Text size="16px">This payment method will be securely stored and used for future billing and automatic charges.</Text>
                                        </FlexColumn>

                                        <FlexColumn start gap="24px" fullWidth style={{ marginTop: 0, padding: 24 }}>
                                            <AutoDebitInformation
                                                name={name}
                                                email={email}
                                                paymentAmount={paymentAmount}
                                                errorField={errorField}
                                                errorMessage={errorMessage}
                                                setName={(name) => this.setState({ name })}
                                                setEmail={(email) => this.setState({ email })}
                                                setAmount={(paymentAmount) => this.setState({ paymentAmount })}
                                            />

                                            {refNum && <PaymentOptions
                                                title="Payment methods"
                                                loading={aionAccountsLoading}
                                                payLoading={payLoading}
                                                businessName={businessName}
                                                onLogin={() => this.setState({ showSignIn: true })}
                                                accounts={accounts}
                                                pay={this.pay}
                                                errorField={errorField}
                                                errorMessage={errorMessage}
                                                width='694px'
                                                plaid
                                                refNum={refNum}
                                                bottomCTA
                                            />}
                                        </FlexColumn>

                                        <FlexColumn gap='8px' left end grow style={{ padding: '24px 24px 0' }}>
                                            <PoweredByAion />
                                            <AICPAAutoDebit businessName={businessName} />
                                        </FlexColumn>
                                    </Skeleton>
                                </FlexColumn>
                            </>
                    }

                    <Modal
                        visible={this.state.showSignIn}
                        footer={null}
                        closable={true}
                        width={448}
                        destroyOnClose={true}
                        onCancel={() => { this.setState({ showSignIn: false }) }}
                        closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                    >
                        <SignInModal validationComplete={(registeredUser) => {
                            this.setState({ showSignIn: false })
                            console.log("validationComplete registeredUser", registeredUser)

                            this.getAccounts()
                        }} />
                    </Modal>
                </Flex>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        creditStore: state.creditAppReducer,
        onboardingStore: state.onboardingAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        doSignout: (history, arg1, arg2, arg3) => dispatch(doSignout(history, arg1, arg2, arg3))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(AutoDebitPaymentMethod)));